/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The CampaignControllerDtoCampaignLockStateRequest model module.
 * @module model/CampaignControllerDtoCampaignLockStateRequest
 * @version 1.0
 */
class CampaignControllerDtoCampaignLockStateRequest {
    /**
     * Constructs a new <code>CampaignControllerDtoCampaignLockStateRequest</code>.
     * @alias module:model/CampaignControllerDtoCampaignLockStateRequest
     * @param campaignNo {Number} 
     * @param isLock {Boolean} 
     */
    constructor(campaignNo, isLock) { 
        
        CampaignControllerDtoCampaignLockStateRequest.initialize(this, campaignNo, isLock);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, campaignNo, isLock) { 
        obj['campaignNo'] = campaignNo;
        obj['isLock'] = isLock;
    }

    /**
     * Constructs a <code>CampaignControllerDtoCampaignLockStateRequest</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/CampaignControllerDtoCampaignLockStateRequest} obj Optional instance to populate.
     * @return {module:model/CampaignControllerDtoCampaignLockStateRequest} The populated <code>CampaignControllerDtoCampaignLockStateRequest</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new CampaignControllerDtoCampaignLockStateRequest();

            if (data.hasOwnProperty('campaignNo')) {
                obj['campaignNo'] = ApiClient.convertToType(data['campaignNo'], 'Number');
            }
            if (data.hasOwnProperty('isLock')) {
                obj['isLock'] = ApiClient.convertToType(data['isLock'], 'Boolean');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>CampaignControllerDtoCampaignLockStateRequest</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>CampaignControllerDtoCampaignLockStateRequest</code>.
     */
    static validateJSON(data) {
        // check to make sure all required properties are present in the JSON string
        for (const property of CampaignControllerDtoCampaignLockStateRequest.RequiredProperties) {
            if (!data[property]) {
                throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
            }
        }

        return true;
    }


}

CampaignControllerDtoCampaignLockStateRequest.RequiredProperties = ["campaignNo", "isLock"];

/**
 * @member {Number} campaignNo
 */
CampaignControllerDtoCampaignLockStateRequest.prototype['campaignNo'] = undefined;

/**
 * @member {Boolean} isLock
 */
CampaignControllerDtoCampaignLockStateRequest.prototype['isLock'] = undefined;






export default CampaignControllerDtoCampaignLockStateRequest;

